import React, { useState, useEffect } from 'react';
import { NavLink, useNavigate, useLocation } from 'react-router-dom';

function FreeformSearch() {
    const location = useLocation();
    const navigate = useNavigate();
    const [keyword, setKeyword] = useState('');
    const error = useState('');

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        setKeyword(params.get('keyword') || '');
    }, [location.search]);

    const handleSubmit = (event) => {
        event.preventDefault();

        const params = new URLSearchParams();
        params.set('keyword', keyword);
        params.set('smode', 'keyword');

        navigate(`/searchresults?${params.toString()}`);
    };
    return (
        <div className="KeywordSearch">
            <div className="tabs">
                <NavLink className={({ isActive }) => isActive ? "tab-link active-tab" : "tab-link"} to="/search">
                    Keyword
                </NavLink>
                <NavLink className={({ isActive }) => isActive ? "tab-link active-tab" : "tab-link"} to="/advanced-search">
                    Advanced
                </NavLink>
                <NavLink className={({ isActive }) => isActive ? "tab-link active-tab" : "tab-link"} to="/freeform-search">
                    Freeform
                </NavLink>
                <NavLink className={({ isActive }) => isActive ? "tab-link active-tab" : "tab-link"} to="/browse">
                    Browse
                </NavLink>
            </div>
            <h2>Freeform Search</h2>
            <form className="search-form" onSubmit={handleSubmit}>
                <input
                    type="text"
                    id="Keyword"
                    name="Keyword"
                    value={keyword}
                    onChange={(e) => setKeyword(e.target.value)}
                    required
                    placeholder="Enter search term(s) here"
                />
                <button type="submit">Search</button>
                <button type="button" onClick={() => setKeyword('')}>
                    Clear
                </button>
            </form>
            {error && <p className="error-message">{error}</p>}
            <div className="search-examples">
                <h3>Examples:</h3>
                <table>
                    <thead>
                        <tr>
                            <th>Keyword</th>
                            <th>Explanation</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td class="sampleQuery">america</td>
                            <td class="sampleDescrip">Search keywords (full text and metadata) for 'america'</td>
                        </tr>

                        <tr>
                            <td class="sampleQuery">south &amp; america</td>
                            <td class="sampleDescrip">(same)</td>
                        </tr>
                        <tr>
                            <td class="sampleQuery">south AND america</td>
                            <td class="sampleDescrip">(same; note 'AND' must be capitalized)</td>
                        </tr>
                        <tr>
                            <td class="sampleQuery">title:south america</td>
                            <td class="sampleDescrip">Search title for 'south' AND 'america'</td>
                        </tr>
                        <tr>
                            <td class="sampleQuery">author:moodley title:america</td>
                            <td class="sampleDescrip">Search author for 'moodley' AND title for 'america'</td>
                        </tr>
                        <tr>
                            <td class="sampleQuery">south | america</td>
                            <td class="sampleDescrip">Search keywords for 'south' OR 'america'</td>
                        </tr>
                        <tr>
                            <td class="sampleQuery">south OR america</td>
                            <td class="sampleDescrip">(same; note 'OR' must be capitalized)</td>
                        </tr>
                        <tr>
                            <td class="sampleQuery">america -south</td>
                            <td class="sampleDescrip">Search keywords for 'america' not near 'south'</td>
                        </tr>
                        <tr>
                            <td class="sampleQuery">america NOT south</td>
                            <td class="sampleDescrip">(same; note 'NOT' must be capitalized)</td>
                        </tr>
                        <tr>
                            <td class="sampleQuery">south (america OR india)</td>
                            <td class="sampleDescrip">Search keywords for 'south' AND either 'america' OR 'india'</td>
                        </tr>
                        <tr>
                            <td class="sampleQuery">south america OR india</td>
                            <td class="sampleDescrip">(same, due to precedence)</td>
                        </tr>
                    </tbody>
                </table>
            </div>

        </div>
    );
}

export default FreeformSearch;
